<template>
  <el-row class="simple-search">
    <el-col>
      <el-form :inline="true" ref="simpleSearchForm" :model="model">
        <slot></slot>
      </el-form>
    </el-col>
    <el-col class="simple-search-button">
      <el-button @click.prevent="clickSearch">検索</el-button>
      <el-button @click.prevent="clickClear">クリア</el-button>
    </el-col>
  </el-row>
</template>

<script>
export default {
  components: {
  },
  props: {
    model: Object,
    category: {
      String,
      default: 'feecalc'
    }
  },
  data () {
    return {}
  },
  methods: {
    clickSearch () {
      this.$refs.simpleSearchForm.validate((valid) => {
        if (valid) {
          this.$emit('search')
        }
      })
    },
    clickClear () {
      this.$refs.simpleSearchForm.resetFields()
      if (this.category === 'feecalc') {
        this.model.billing_ym = this.getDefaultBillingYm()
      }
      if (this.category === 'master') {
        this.$emit('clear')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.simple-search {
  display: flex;
  ::v-deep .el-col {
    width: auto;
    &.simple-search-button {
      display: flex;
      flex-wrap: nowrap;
      align-self: flex-start;
      margin: 0 0 0 auto;
    }
    form {
      display: inline-block;
      width: auto;
    }
    .el-form {
      .el-form-item {
        margin-bottom: 0;
        &.is-required {
          .el-form-item__label {
            &::before {
              content: none;
            }
            &::after {
              content: "●";
              color: #f56c6c;
            }
            span {
              font-size: 70%;
            }
          }
        }
      }
    }
  }
}
</style>
